"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _hikeAdvancedReport = require("@/api/hike-advanced-report");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeAdvReportMain',
  components: {
    HikeAdvReportAdvancedReport: _index.HikeAdvReportAdvancedReport,
    HikeAdvReportInfo: _index.HikeAdvReportInfo
  },
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {
      fullscreenloading: false,
      recordStatus: '',
      hikeAdvReportForm: {
        id: '',
        title: '',
        publish: '',
        start: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        end: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        // locale: 'en',  no use
        description: '',
        reports: [],
        tempInternalTitle: '',
        internal: {
          title: '',
          opportunityNumber: '',
          clientName: '',
          remark: ''
        },
        password: '',
        overallSkillSummary: true,
        individualBreakdown: true,
        individualReport: true,
        showStageAttendance: true,
        showParticipantRate: true,
        groupHighlights: true,
        showNegativeGrowth: false,
        mostActiveHikersMaxCount: 3,
        mostImprovedHikersMaxCount: 3,
        participantFeedback: true,
        showSkillCompass: true,
        showPiExplanation: true,
        metadata: {
          tenant: ''
        }
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['email'])),
  created: function created() {
    if (this.displayType === 'edit') {
      var id = typeof this.$route.params.id === 'undefined' ? this.hikeAdvReportForm.id : this.$route.params.id;
      this.recordStatus = 'edit';
      this.fromId = typeof this.$route.query.fromId === 'undefined' ? '' : this.$route.query.fromId;
      this.getHikeAdvReport(id); // copy mode is false
    } else {
      // create from new
      this.recordStatus = 'create';
    }
  },
  methods: {
    doCreate: function doCreate(publishStatus) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var token, oEmail, msg, _msg, _msg2, startDate, endDate, _msg3, _msg4;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.fullscreenloading = true;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              oEmail = (0, _cookie.getCookie)('EMAIL');
              _this.hikeAdvReportForm.publish = publishStatus;
              _this.hikeAdvReportForm.internal.title = _this.hikeAdvReportForm.tempInternalTitle;

              // validate
              if (!(!_this.hikeAdvReportForm.metadata || _this.hikeAdvReportForm.metadata.tenant === '')) {
                _context.n = 1;
                break;
              }
              _this.fullscreenloading = false;
              msg = 'Please select the tenant';
              (0, _log.displayPopupMessage)(msg, 'error');
              return _context.a(2);
            case 1:
              if (!(_this.hikeAdvReportForm.title === '')) {
                _context.n = 2;
                break;
              }
              _this.fullscreenloading = false;
              _msg = 'Title is missing';
              (0, _log.displayPopupMessage)(_msg, 'error');
              return _context.a(2);
            case 2:
              if (!(_this.hikeAdvReportForm.start.utc === '' || _this.hikeAdvReportForm.end.utc === '')) {
                _context.n = 3;
                break;
              }
              _this.fullscreenloading = false;
              _msg2 = "Report availability period is missing";
              (0, _log.displayPopupMessage)(_msg2, 'error');
              return _context.a(2);
            case 3:
              startDate = new Date(_this.hikeAdvReportForm.start.utc);
              endDate = new Date(_this.hikeAdvReportForm.end.utc);
              if (!(startDate > endDate)) {
                _context.n = 4;
                break;
              }
              _this.fullscreenloading = false;
              _msg3 = 'Start-Time is later than End-Time in Availability period';
              (0, _log.displayPopupMessage)(_msg3, 'error');
              return _context.a(2);
            case 4:
              if (!(_this.hikeAdvReportForm.start.timezone === '' || _this.hikeAdvReportForm.end.timezone === '')) {
                _context.n = 5;
                break;
              }
              _this.fullscreenloading = false;
              _msg4 = 'Timezone is missing';
              (0, _log.displayPopupMessage)(_msg4, 'error');
              return _context.a(2);
            case 5:
              // submit
              if (_this.hikeAdvReportForm.id === '') {
                (0, _hikeAdvancedReport.createAdvancedReport)(token, _this.hikeAdvReportForm).then(function (response) {
                  (0, _log.showDebugLog)('Hike-create-response1', response);
                  _this.fullscreenloading = false;
                  _this.hikeAdvReportForm.id = response.data.id;
                  _this.hikeAdvReportForm.publish = response.data.publish;

                  // console.log('Success create', this.displayType)
                  var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is created.");
                  (0, _log.displayPopupMessage)(msg, 'success');
                  (0, _ga.writeGaEvent)(_this, 'HikeAdvancedReport', "".concat(_lifehikesInitData.userEvent.hikeAdvancedReport.create), oEmail, "Hike Id: ".concat(_this.hikeAdvReportForm.id));
                  if (_this.displayType === 'create') {
                    _this.$router.push("/hike-advanced-report/edit/".concat(response.data.id));
                  }
                }).catch(function (error) {
                  (0, _log.showDebugLog)('hike-create-error', error);
                  _this.fullscreenloading = false;
                  (0, _log.displayPopupMessage)(error, 'error');
                });
              }
            case 6:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    doSave: function doSave(publishStatus) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, oEmail, id, msg, _msg5, _msg6, startDate, endDate, _msg7;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.fullscreenloading = true;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              oEmail = (0, _cookie.getCookie)('EMAIL');
              id = typeof _this2.$route.params.id === 'undefined' ? _this2.hikeAdvReportForm.id : _this2.$route.params.id;
              _this2.hikeAdvReportForm.publish = publishStatus;
              _this2.hikeAdvReportForm.internal.title = _this2.hikeAdvReportForm.tempInternalTitle + '';

              // validate
              if (!(!_this2.hikeAdvReportForm.metadata || _this2.hikeAdvReportForm.metadata.tenant === '')) {
                _context2.n = 1;
                break;
              }
              _this2.fullscreenloading = false;
              msg = 'Please select the tenant';
              (0, _log.displayPopupMessage)(msg, 'error');
              return _context2.a(2);
            case 1:
              if (!(_this2.hikeAdvReportForm.title === '')) {
                _context2.n = 2;
                break;
              }
              _this2.fullscreenloading = false;
              _msg5 = "Title is missing";
              (0, _log.displayPopupMessage)(_msg5, 'error');
              return _context2.a(2);
            case 2:
              if (!(_this2.hikeAdvReportForm.start.utc === '' || _this2.hikeAdvReportForm.end.utc === '')) {
                _context2.n = 3;
                break;
              }
              _this2.fullscreenloading = false;
              _msg6 = "Report availability period is missing";
              (0, _log.displayPopupMessage)(_msg6, 'error');
              return _context2.a(2);
            case 3:
              startDate = new Date(_this2.hikeAdvReportForm.start.utc);
              endDate = new Date(_this2.hikeAdvReportForm.end.utc);
              if (!(startDate > endDate)) {
                _context2.n = 4;
                break;
              }
              _this2.fullscreenloading = false;
              _msg7 = 'Start-Time is later than End-Time in Availability period';
              (0, _log.displayPopupMessage)(_msg7, 'error');
              return _context2.a(2);
            case 4:
              // submit
              (0, _log.showDebugLog)('Save Form', _this2.hikeAdvReportForm);
              (0, _hikeAdvancedReport.updateAdvancedReport)(token, id, _this2.hikeAdvReportForm).then(function (response) {
                (0, _log.showDebugLog)('Hike-update-response', response);
                _this2.fullscreenloading = false;
                _this2.hikeAdvReportForm.id = response.data.id;
                _this2.hikeAdvReportForm.publish = response.data.publish;
                var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is updated.");
                (0, _log.displayPopupMessage)(msg, 'success');
                (0, _ga.writeGaEvent)(_this2, 'HikeAdvancedReport', "".concat(_lifehikesInitData.userEvent.hikeAdvancedReport.edit), oEmail, "Edit in Hike Advanced Report Main - Hike Advanced Report Id: ".concat(_this2.hikeAdvReportForm.id));
              }).catch(function (error) {
                (0, _log.showDebugLog)('Hike-update-error', error);
                _this2.fullscreenloading = false;
                (0, _log.displayPopupMessage)(error, 'error');
              });

              // this.flagRemindSave = (this.hikeAdvReportForm.stages[0].taskSortDay)? false : true
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getHikeAdvReport: function getHikeAdvReport(id) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _hikeAdvancedReport.getAdvancedReportById)(token, id).then(function (response) {
        var d = response.data;
        // check error and return immediate
        if (typeof d.id === 'undefined') {
          _this3.fullscreenloading = false;
          var msg = 'Cannot get the hike, please contact to system administrator';
          (0, _log.displayPopupMessage)(msg, 'error');
          return;
        }
        _this3.hikeAdvReportForm.id = d.id;
        _this3.hikeAdvReportForm.reports = d.reports;
        _this3.hikeAdvReportForm.password = typeof d.password === 'undefined' ? '' : d.password;
        _this3.hikeAdvReportForm.overallSkillSummary = typeof d.overallSkillSummary === 'undefined' ? true : d.overallSkillSummary;
        _this3.hikeAdvReportForm.individualBreakdown = typeof d.individualBreakdown === 'undefined' ? true : d.individualBreakdown;
        _this3.hikeAdvReportForm.individualReport = typeof d.individualReport === 'undefined' ? true : d.individualReport;
        _this3.hikeAdvReportForm.groupHighlights = typeof d.groupHighlights === 'undefined' ? true : d.groupHighlights;
        _this3.hikeAdvReportForm.showNegativeGrowth = typeof d.showNegativeGrowth === 'undefined' ? false : d.showNegativeGrowth;
        _this3.hikeAdvReportForm.mostActiveHikersMaxCount = typeof d.mostActiveHikersMaxCount === 'undefined' ? 3 : d.mostActiveHikersMaxCount;
        _this3.hikeAdvReportForm.mostImprovedHikersMaxCount = typeof d.mostImprovedHikersMaxCount === 'undefined' ? 3 : d.mostImprovedHikersMaxCount;
        _this3.hikeAdvReportForm.showStageAttendance = typeof d.showStageAttendance === 'undefined' ? true : d.showStageAttendance;
        _this3.hikeAdvReportForm.showParticipantRate = typeof d.showParticipantRate === 'undefined' ? true : d.showParticipantRate;
        _this3.hikeAdvReportForm.participantFeedback = typeof d.participantFeedback === 'undefined' ? true : d.participantFeedback;
        _this3.hikeAdvReportForm.showSkillCompass = typeof d.showSkillCompass === 'undefined' ? true : d.showSkillCompass;
        _this3.hikeAdvReportForm.showPiExplanation = typeof d.showPiExplanation === 'undefined' ? true : d.showPiExplanation;
        _this3.hikeAdvReportForm.title = typeof d.title === 'undefined' ? '' : d.title;
        _this3.hikeAdvReportForm.internal.title = typeof d.title === 'undefined' ? '' : d.internal.title;
        _this3.hikeAdvReportForm.description = typeof d.description === 'undefined' ? '' : d.description;
        _this3.hikeAdvReportForm.internal.opportunityNumber = typeof d.internal === 'undefined' ? '' : d.internal.opportunityNumber;
        _this3.hikeAdvReportForm.publish = typeof d.publish === 'undefined' ? '' : d.publish;
        // start date
        if (typeof d.start === 'undefined') {
          _this3.hikeAdvReportForm.start = {
            utc: '',
            timezone: _momentTimezone.default.tz.guess(),
            local: ''
          };
        } else {
          _this3.hikeAdvReportForm.start.utc = typeof d.start.utc === 'undefined' ? '' : d.start.utc;
          _this3.hikeAdvReportForm.start.local = typeof d.start.local === 'undefined' ? '' : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
          _this3.hikeAdvReportForm.start.timezone = typeof d.start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.start.timezone;
        }

        // end date
        if (typeof d.end === 'undefined') {
          _this3.hikeAdvReportForm.end = {
            utc: '',
            timezone: _momentTimezone.default.tz.guess(),
            local: ''
          };
        } else {
          _this3.hikeAdvReportForm.end.utc = typeof d.end.utc === 'undefined' ? '' : d.end.utc; // d.end.utc.toISOString()
          _this3.hikeAdvReportForm.end.local = typeof d.end.local === 'undefined' ? '' : d.end.local; // moment(d.start.end).tz(moment.tz.guess()).toString() // d.end.local // d.end.utc.toISOString()
          _this3.hikeAdvReportForm.end.timezone = typeof d.end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.end.timezone;
        }

        // metadata
        _this3.hikeAdvReportForm.metadata = typeof d.metadata === 'undefined' ? {
          tenant: ''
        } : d.metadata;

        // To Solve internal title lagging issue, use other variable name to replace.
        _this3.hikeAdvReportForm.tempInternalTitle = _this3.hikeAdvReportForm.internal.title + '';
        _this3.fullscreenloading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        _this3.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    updateParentReportInfo: function updateParentReportInfo(info) {
      // console.log('updateParentReportInfo:')
      // console.log(info)
    },
    updateParentReports: function updateParentReports(reports) {
      this.$set(this.hikeAdvReportForm, 'reports', reports);
    },
    handleClick: function handleClick() {
      // do something later
      // auto save when change tab
    },
    checkArrayLength: function checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    }
  }
};